import { useAuthActions } from "@convex-dev/auth/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useAppStore from "../../stores/appStore";
import useFileStore from "../../stores/fileStore";
import useAIStore from "../../stores/aiStore";
import usePendingChangesStore from "../../stores/pendingChangesStore";

function SignOutButton({ className = "", label }) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('auth.signOut');
  const { signOut } = useAuthActions();
  const navigate = useNavigate();
  const resetApp = useAppStore((state) => state.reset);
  const resetFiles = useFileStore((state) => state.reset);
  const resetAI = useAIStore((state) => state.reset);
  const clearPending = usePendingChangesStore((state) => state.clear);

  const handleSignOut = async () => {
    await signOut();
    resetApp();
    resetFiles();
    resetAI();
    clearPending();
    navigate("/");
  };

  return (
    <button className={`btn btn-ghost btn-sm ${className}`} onClick={handleSignOut}>
      {resolvedLabel}
    </button>
  );
}

export default SignOutButton;
